import * as yup from 'yup';

const expirationDateRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;

// TODO Translates
export const cardFillSchema = yup.object({
  card_number: yup.string().required('Card number is required'),
  expiry_date: yup.string().required('Expiration date is required').matches(expirationDateRegex, 'Expiration date must be in MM/YY format'),
  cvv2: yup
    .string()
    .required('CCV is required')
    .matches(/^\d{3,4}$/, 'CCV must be 3 or 4 digits'),
});